import { AccordionGroup } from "@dealer-center/core-components";
import { LaunchDarklyAccordionItem } from "./LaunchDarklyAccordionItem";
import { UserAccordionItem } from "./UserAccordionItem";
import { DealerEntityAccordionItem } from "./DealerEntityAccordionItem";
import { VersionJsonAccordionItem } from "./VersionJsonAccordionItem";
import { useEffect } from "react";
import type { GenericFlags } from "@dealer-center/core-interfaces-third-party-launch-darkly";
import type {
  AutotraderFlagNames,
  CC9FlagNames
} from "@dealer-center/core-interfaces-third-party-launch-darkly";

export interface CorePagesAboutProps {
  accountEntityJsonString?: string;
  userEntityJsonString: string;
  rootPath: string;
  flags: GenericFlags<CC9FlagNames> | GenericFlags<AutotraderFlagNames>;
}
export const CorePagesAbout = ({
  accountEntityJsonString,
  userEntityJsonString,
  flags,
  rootPath
}: CorePagesAboutProps) => {
  useEffect(() => {
    document.title = "About";
  }, []);
  return (
    <>
      <h1>About</h1>
      <AccordionGroup>
        <VersionJsonAccordionItem rootPath={rootPath} />
        {accountEntityJsonString ? (
          <DealerEntityAccordionItem accountEntity={accountEntityJsonString} />
        ) : (
          <></>
        )}
        <UserAccordionItem userEntity={userEntityJsonString} />
        <LaunchDarklyAccordionItem flags={flags} />
      </AccordionGroup>
    </>
  );
};
